const faqs = [
  {
    q: '天堂影院的电影需要付费观看吗？',
    a: '完全免费！天堂影院所有高清电影均免费在线观看，无需注册、无需付费、无需会员。我们致力于为用户提供零门槛的高清影视在线观看体验，让每个人都能轻松享受电影带来的快乐。',
  },
  {
    q: '观看电影时需要安装播放器或插件吗？',
    a: '不需要。天堂影院采用 HTML5 播放技术，支持主流浏览器直接播放。您只需打开网页即可流畅观影，无需下载任何播放器、插件或APP。',
  },
  {
    q: '为什么有些电影播放会卡顿？如何切换线路？',
    a: '播放卡顿通常与您当前的网络环境有关。天堂影院为每部影片提供了多条播放线路，您可以在播放器右下角点击"切换线路"，选择当前最流畅的线路即可。推荐使用 Chrome 或 Edge 浏览器获得最佳体验。',
  },
  {
    q: '天堂影院的电影画质如何？支持哪些清晰度？',
    a: '天堂影院的电影资源以高清为主，大多数影片支持 1080P 全高清播放，部分热门大片更支持 4K 超清画质。您可根据自己的网络带宽在播放器中自由切换清晰度，从流畅到蓝光随心选择。',
  },
  {
    q: '电影更新频率如何？能看到最新上映的影片吗？',
    a: '天堂影院的片源团队每日更新，第一时间同步院线新片与网络首映资源。首页"本周精选"和"最新动态"模块实时展示最新入库影片，热门大片通常在首映后 48 小时内即可在线观看。',
  },
  {
    q: '天堂影院有广告吗？观影体验如何？',
    a: '天堂影院承诺：全站无任何形式的贴片广告、弹窗广告或强制广告。我们始终把用户观影体验放在首位，从打开页面到影片结束，您只需专注于电影本身，不会受到任何广告干扰。',
  },
];

import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            关于天堂影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-[800px] mx-auto flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-lg bg-background-200/60 border border-background-200/50 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === idx ? -1 : idx)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <span className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-300 text-foreground-500 transition-transform duration-300 ${openIndex === idx ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === idx ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-400 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}